import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiInstance } from "./axiosApi";
import authHeader from "./authHeader";

export const getUserData = createAsyncThunk(
  "user/all",
  async ({ page, limit, searchData, filter }) => {
    let url = `/user/all?page=${page}&limit=${limit}`;
    if (searchData) {
      url += `&search=${searchData}`;
    }
    if (filter) {
      url += `&blockFilter=${filter}`;
    }

    return await apiInstance.get(url, {
      headers: authHeader(),
    });
  }
);
export const userEditData = createAsyncThunk("user/edit", async (payload) => {
  return await apiInstance.post(`/user/edit`, payload, {
    headers: authHeader(),
  });
});

const initialState = {
  studentLoading: false,
};

const studentSlice = createSlice({
  name: "studentSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUserData.pending, (state, action) => {
      state.studentLoading = true;
    });
    builder.addCase(getUserData.fulfilled, (state, action) => {
      state.studentData = action.payload.data;
      state.studentLoading = false;
    });
    builder.addCase(getUserData.rejected, (state, action) => {
      state.studentLoading = false;
    });
  },
});
export default studentSlice.reducer;